export const SUBSCRIBE_API_URL = '/api/v1/users/subscribe/';
export const NEWSLETTERS_API_URL = '/api/v1/newsletters/';
export const SECONDARY_INTEREST_ID = 'c1926c28df';
export const SELECTOR = 'newsletter-subscribe';
export const RECAPTCHA_ACTION = 'NEWSLETTER_SIGNUP';
export const GENERIC_ERROR_MSG =
  "We're sorry. Your newsletter sign-up didn't go through. If the problem persists, email us at community@texastribune.org for help.";
